import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import { styled, Tooltip, Button } from '@mui/material';

/**
 * Toolbar container for Quill editor
 */
var QuillToolbar = function QuillToolbar(_ref) {
  var id = _ref.id,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, children);
};

QuillToolbar.propTypes = {
  children: propTypes.node
};

/** Groups one or more toolbar buttons together */
QuillToolbar.Group = function (_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("span", {
    className: "ql-formats"
  }, children);
};

var QuillToolbarButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "text"
  }, props, {
    ref: ref
  }));
});
/** Base component for toolbar buttons */

QuillToolbar.Button = styled(QuillToolbarButton)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    minWidth: 32,
    width: 32,
    height: 32,
    paddingLeft: 6,
    paddingRight: 6,
    "&.ql-active": {
      backgroundColor: theme.palette.grey[300],
      outline: "1px solid ".concat(theme.palette.grey[500])
    }
  };
});
/** Base component for toolbar button tooltips */

QuillToolbar.Tooltip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    placement: "bottom-start",
    describeChild: true,
    PopperProps: {
      disablePortal: true
    }
  }, props, {
    ref: ref
  }));
});

/** Toolbar button to select heading font size */
QuillToolbar.Heading = function (_ref4) {
  var _ref4$title = _ref4.title,
      title = _ref4$title === void 0 ? "Heading" : _ref4$title,
      _ref4$options = _ref4.options,
      options = _ref4$options === void 0 ? [{
    value: "1",
    label: "Heading 1"
  }, {
    value: "2",
    label: "Heading 2"
  }, {
    value: "3",
    label: "Heading 3"
  }, {
    value: "",
    label: ""
  }] : _ref4$options;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    }
  }, /*#__PURE__*/React.createElement("select", {
    className: "ql-header",
    defaultValue: ""
  }, options.map(function (o) {
    return /*#__PURE__*/React.createElement("option", {
      key: o.value,
      value: o.value
    }, o.label);
  }))));
};
/** Toolbar button to toggle bold formatting */


QuillToolbar.Bold = function (_ref5) {
  var _ref5$title = _ref5.title,
      title = _ref5$title === void 0 ? "Bold" : _ref5$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-bold"
  }));
};
/** Toolbar button to toggle italic formatting */


QuillToolbar.Italic = function (_ref6) {
  var _ref6$title = _ref6.title,
      title = _ref6$title === void 0 ? "Italic" : _ref6$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-italic"
  }));
};
/** Toolbar button to toggle underline formatting */


QuillToolbar.Underline = function (_ref7) {
  var _ref7$title = _ref7.title,
      title = _ref7$title === void 0 ? "Underline" : _ref7$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-underline"
  }));
};
/** Toolbar button to toggle strikethrough formatting */


QuillToolbar.Strikethrough = function (_ref8) {
  var _ref8$title = _ref8.title,
      title = _ref8$title === void 0 ? "Strikethrough" : _ref8$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-strike"
  }));
};
/** Toolbar button to toggle a numbered list */


QuillToolbar.NumberedList = function (_ref9) {
  var _ref9$title = _ref9.title,
      title = _ref9$title === void 0 ? "Numbered List" : _ref9$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-list",
    value: "ordered"
  }));
};
/** Toolbar button to toggle a bullet list */


QuillToolbar.BulletList = function (_ref10) {
  var _ref10$title = _ref10.title,
      title = _ref10$title === void 0 ? "Bullet List" : _ref10$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-list",
    value: "bullet"
  }));
};
/** Toolbar button to align text to the left */


QuillToolbar.AlignLeft = function (_ref11) {
  var _ref11$title = _ref11.title,
      title = _ref11$title === void 0 ? "Align Left" : _ref11$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-align",
    value: ""
  }));
};
/** Toolbar button to align text to the middle */


QuillToolbar.AlignMiddle = function (_ref12) {
  var _ref12$title = _ref12.title,
      title = _ref12$title === void 0 ? "Align Middle" : _ref12$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-align",
    value: "center"
  }));
};
/** Toolbar button to align text to the right */


QuillToolbar.AlignRight = function (_ref13) {
  var _ref13$title = _ref13.title,
      title = _ref13$title === void 0 ? "Align Right" : _ref13$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-align",
    value: "right"
  }));
};
/** Toolbar button to select text color */


QuillToolbar.TextColor = function (_ref14) {
  var _ref14$title = _ref14.title,
      title = _ref14$title === void 0 ? "Text Colour" : _ref14$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    }
  }, /*#__PURE__*/React.createElement("select", {
    className: "ql-color"
  })));
};
/** Toolbar button to select background color */


QuillToolbar.BackgroundColor = function (_ref15) {
  var _ref15$title = _ref15.title,
      title = _ref15$title === void 0 ? "Background Colour" : _ref15$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    }
  }, /*#__PURE__*/React.createElement("select", {
    className: "ql-background"
  })));
};
/** Toolbar button to insert a link */


QuillToolbar.Link = function (_ref16) {
  var _ref16$title = _ref16.title,
      title = _ref16$title === void 0 ? "Insert Link" : _ref16$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-link"
  }));
};
/** Toolbar button to insert an image */


QuillToolbar.Image = function (_ref17) {
  var _ref17$title = _ref17.title,
      title = _ref17$title === void 0 ? "Insert Image" : _ref17$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-image"
  }));
};
/** Toolbar button to clear existing formatting */


QuillToolbar.Clear = function (_ref18) {
  var _ref18$title = _ref18.title,
      title = _ref18$title === void 0 ? "Clear Formatting" : _ref18$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-clean"
  }));
};
/** Toolbar button to undo the previous change */


QuillToolbar.Undo = function (_ref19) {
  var _ref19$title = _ref19.title,
      title = _ref19$title === void 0 ? "Undo" : _ref19$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-undo"
  }));
};
/** Toolbar button to redo the previous change */


QuillToolbar.Redo = function (_ref20) {
  var _ref20$title = _ref20.title,
      title = _ref20$title === void 0 ? "Redo" : _ref20$title;
  return /*#__PURE__*/React.createElement(QuillToolbar.Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(QuillToolbar.Button, {
    className: "ql-redo"
  }));
};

var QuillToolbar$1 = QuillToolbar;

export { QuillToolbar$1 as default };
